

































































import { Component, Prop, Vue } from "vue-property-decorator";
import { apiService, AppConstants, Interfaces, Models } from "@/core/Export";
import store from "@/store";
@Component({
  components: {},
})
export default class AdditionListItem extends Vue {
  @Prop() dayData: Models.EmployeeDayAdditionalPortalItemDto;
  @Prop() valueType: Array<any>;
  empAdditionTypeCodes = AppConstants.EmpAdditionTypeCodes;
  sourceCodeTypes = AppConstants.SourceCode;
  $q;

  constructor() {
    super();
  }
  created() { }

  onEditAdditional(line) {
    this.$emit("clickEditItem", line.id);
  }

  onDeleteAdditional(line) {
    this.$q
      .dialog({
        title: this.$t("verification"),
        message: this.$t("msgs.employee_try_to_delete_additional_verify"),
        cancel: this.$t("reject"),
        ok: this.$t("approve"),
        persistent: true,
        html: false,
        focus: "none",
        class: "health_declaration_dialog",
      })
      .onOk(() => this.deleteAdditionalData(line));
  }

  deleteAdditionalData(addition) {
    this.appEnv.isBusy = true;
    apiService
      .deleteAdditionalPortal(addition.id)
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.$emit("clickDeleteItem");
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
      })
      .finally(() => (this.appEnv.isBusy = false));
  }

  getValueTypeName(valueTypeCode) {
    const valueType = this.valueType.find((x) => x.code == valueTypeCode);
    return valueType ? valueType.name : "";
  }

  get canEditMonth() {
    return store.getters.canEditMonth;
  }

  get appEnv() {
    return store.state.appEnv;
  }
}
